import React, { FC } from 'react';
import Icon from './Icon';

type Props = {};

const Footer: FC<Props> = () => {
  return (
    <footer className="bg-gray-900 h-16 text-gray-500 flex items-center justify-center">
      <p className="mr-4 px-4">Folgen Sie uns auf unseren Social-Media-Kanälen!</p>
      <div className="flex">
        <a href="https://www.facebook.com/pg/tanzstudioaha" target="_blank">
          <Icon className="w-8 h-8 mr-4" name="facebook" />
        </a>
        <a href="https://www.instagram.com/ahatanzstudio/" target="_blank">
          <Icon className="w-8 h-8 mr-4" name="instagram" />
        </a>
      </div>
    </footer>
  );
};
export default Footer;
